import React from 'react'
import { Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { columnsList } from '../components/TableType'

//主页
export default function HomePage() {
    const navigate = useNavigate();
    //选择bucket加载
    async function handleBtnClick(e) {
        navigate('/bucket', { state: e.bucket });
    }

    return (
        <>
            <div id='home'>
                <Space direction="vertical" style={{ width: '100%' }}>
                    {columnsList.map((e, i) => {
                        return <Button key={i} type="text" block style={{ textAlign: 'left', fontWeight: 600 }} onClick={() => handleBtnClick(e)}>
                            {e?.bucket}
                        </Button>
                    })}
                </Space>
            </div>
        </ >
    )
}

